import { Modal as ModalModule } from 'common';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;
const paymentMethodNames = ['', 'Check', 'ACH Credit', 'Overdraft'];

const ReviewTransactionModal = ({
	data: {
		totalAmount,
		locationsAllocated,
		paymentMethod,
		billingAddress,
		callback,
	},
	modalId,
}) => (
	<Modal
		modalId={modalId}
		className="account-allocate-funds review-transaction-modal"
		header="Review Transaction"
		primaryButton={{
			type: ModalButtonActionType.Ok,
			onClick: () => callback(modalId),
			text: 'Submit',
		}}
		secondaryButton={{
			type: ModalButtonActionType.Cancel,
			text: 'Cancel',
		}}
		size="small"
	>
		<div className="body">
			<p className="body-text">
				Please confirm your transaction details below:
			</p>
			<div className="p-grid">
				<div className="p-col-6 field-label">Total Fund Amount:</div>
				<div className="p-col-6">${totalAmount.toFixed(2)}</div>

				<div className="p-col-6 field-label">Number of Locations:</div>
				<div className="p-col-6">{locationsAllocated}</div>

				<div className="p-col-6 field-label">Payment Method:</div>
				<div className="p-col-6">{paymentMethodNames[paymentMethod]}</div>

				<div className="p-col-6 field-label">Billing Address:</div>
				<div className="p-col-6">{billingAddress}</div>
			</div>
		</div>
	</Modal>
);

export default ReviewTransactionModal;
